(function () {
  function getColumnCount(width) {
    if (width >= 1200) return 6;
    if (width >= 990) return 4;
    if (width >= 750) return 3;
    return 2;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function initSection(section) {
    var grid = section.querySelector('[data-pr-grid]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-pr-card]'));
    var showMoreBtn = section.querySelector('[data-pr-show-more]');
    var initialVisible = parseInt(section.getAttribute('data-initial-visible'), 10) || cards.length;

    // ---- masonry packing: place each card into whichever column is
    // currently shortest, so cards "flow up" into any open space
    // instead of just stacking in reading-order rows. ----
    function layoutMasonry() {
      var containerWidth = grid.clientWidth;
      if (!containerWidth) return;

      var gap = parseFloat(getComputedStyle(grid).getPropertyValue('--pr-gap')) || 13;
      var columns = getColumnCount(containerWidth);
      // Floor + a 1px safety margin so accumulated rounding across
      // columns can never push the last card past the container edge
      // and trigger page-wide horizontal scroll on mobile.
      var colWidth = Math.floor((containerWidth - gap * (columns - 1) - 1) / columns);
      var colHeights = new Array(columns).fill(0);

      var visible = cards.filter(function (card) {
        return !card.hasAttribute('data-pr-hidden');
      });

      visible.forEach(function (card) {
        card.style.width = colWidth + 'px';
        var col = colHeights.indexOf(Math.min.apply(null, colHeights));
        var x = Math.round(col * (colWidth + gap));
        var y = Math.round(colHeights[col]);
        card.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        colHeights[col] = y + card.offsetHeight + gap;
      });

      grid.style.height = Math.max(0, Math.max.apply(null, colHeights) - gap) + 'px';
      grid.classList.add('is-packed');
    }

    var relayout = debounce(layoutMasonry, 120);
    window.addEventListener('resize', relayout);
    window.addEventListener('orientationchange', relayout);
    window.addEventListener('load', relayout);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(layoutMasonry);
    }
    section.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', relayout);
    });

    var writeReviewBtn = section.querySelector('[data-pr-write-review]');
    if (writeReviewBtn) {
      writeReviewBtn.addEventListener('click', function () {
        section.dispatchEvent(new CustomEvent('pr:write-review', { bubbles: true }));
      });
    }

    // ---- reveal / show more ----
    var revealCount = initialVisible;

    function applyVisibility() {
      cards.forEach(function (card, index) {
        if (index < revealCount) {
          card.removeAttribute('data-pr-hidden');
        } else {
          card.setAttribute('data-pr-hidden', '');
        }
      });
      if (showMoreBtn) {
        showMoreBtn.style.display = revealCount >= cards.length ? 'none' : '';
      }
      layoutMasonry();
    }

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        revealCount = cards.length;
        applyVisibility();
      });
    }

    applyVisibility();

    // ---- sort dropdown ----
    var sortWrap = section.querySelector('[data-pr-sort]');
    var sortToggle = section.querySelector('[data-pr-sort-toggle]');
    var sortMenu = section.querySelector('[data-pr-sort-menu]');
    var sortOptions = section.querySelectorAll('.pr-sort-option');

    function closeMenu() {
      sortMenu.hidden = true;
      sortToggle.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      sortMenu.hidden = false;
      sortToggle.setAttribute('aria-expanded', 'true');
    }

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        sortMenu.hidden ? openMenu() : closeMenu();
      });

      document.addEventListener('click', function (e) {
        if (!sortWrap.contains(e.target)) closeMenu();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
      });
    }

    function sortCards(mode) {
      var sorted = cards.slice();

      if (mode === 'highest') {
        sorted.sort(function (a, b) {
          return parseFloat(b.getAttribute('data-rating')) - parseFloat(a.getAttribute('data-rating'));
        });
      } else if (mode === 'lowest') {
        sorted.sort(function (a, b) {
          return parseFloat(a.getAttribute('data-rating')) - parseFloat(b.getAttribute('data-rating'));
        });
      } else if (mode === 'newest') {
        sorted.sort(function (a, b) {
          return parseFloat(b.getAttribute('data-date')) - parseFloat(a.getAttribute('data-date'));
        });
      } else {
        sorted.sort(function (a, b) {
          return parseFloat(a.getAttribute('data-order')) - parseFloat(b.getAttribute('data-order'));
        });
      }

      sorted.forEach(function (card) {
        grid.appendChild(card);
      });

      cards = sorted;
      applyVisibility();
    }

    sortOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        sortOptions.forEach(function (o) {
          o.classList.remove('is-active');
          var check = o.querySelector('.pr-check-icon');
          if (check) check.remove();
        });
        option.classList.add('is-active');
        option.insertAdjacentHTML(
          'beforeend',
          '<svg class="pr-check-icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        );
        sortCards(option.getAttribute('data-sort'));
        closeMenu();
      });
    });
  }

  document.querySelectorAll('.pr-section').forEach(initSection);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.pr-section');
    if (section) initSection(section);
  });
})();